import { colors, fontSizes } from 'theme'
import css from 'styled-jsx/css'

export default css`
  .password-strength-indicator {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }

  .strength-bar-container {
    height: 4px;
    background: ${colors.dullGray};
    border-radius: 2px;
    overflow: hidden;
    margin-bottom: 0.5rem;
  }

  .strength-bar {
    height: 100%;
    border-radius: 2px;
    transition: width 0.3s ease, background-color 0.3s ease;
  }

  .strength-bar.weak {
    background-color: ${colors.danger};
  }

  .strength-bar.medium {
    background-color: ${colors.warning};
  }

  .strength-bar.strong {
    background-color: ${colors.success};
  }

  .requirements-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem 1rem;
  }

  .requirements-list li {
    font-size: ${fontSizes.small};
    color: ${colors.lightText};
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }

  .requirements-list li.met {
    color: ${colors.success};
  }

  .requirements-list li .check {
    font-size: 0.75rem;
    width: 1rem;
    text-align: center;
  }
`
